/**
 * Created by idea on 27/03/2017.
 */
import {Component, Input} from '@angular/core';
import {UtilityService} from '../services/Utility.service';
import 'intl';
import 'intl/locale-data/jsonp/en'

declare var $:any;

@Component({
    selector: 'ick-date',
    template: `{{date}}`
})
export class DateComponent{
    private _date;

    @Input()
    set date(value : string){
        if(value == "null" || value == ""){
            this._date = 'không xác định';
        }else{
            if($.isNumeric(value) == false){
                this._date = UtilityService.dateFormat(value);
            }else{
                this._date = UtilityService.dateFormat(parseInt(value));
            }
        }
    }
    get date(){
        return this._date;
    }

    constructor(){
    }
}


// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/helper/date.component.ts